import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { Request } from '../../../ts/ServerApi/requests/Request';

export interface IDisableWorkbookAccelerationParams {
  targetIds: string[];
}

export class DisableWorkbookAccelerationRequest extends Request<IDisableWorkbookAccelerationParams, IResult> {
  constructor(params: IDisableWorkbookAccelerationParams) {
    super('disableWorkbookAcceleration', params);
  }
}
